<template>
  <widgetModal :title="type == 'evaluation' ? `Send Form` : `Send Survey`" :subtitle="value.title" btnlefttext="Send"
    btncentertext="Cancel" btnrighttext="" :loading="signature_loading" :leftloading="send_loading" :rightloading="false"
    :centerloading="false" :footerhidden="false" footer_padding="20px 20px" header_padding="20px 20px"
    body_padding="0px 20px" width="580px" @onLeftClick="submitSurvey()" @onCenterClick="onCancel">
    <div class="widget-modal-body-noscoll">
      <widgetInputWrapper title="Send to:">
        <widgetClassDropdown v-model="form.classes"></widgetClassDropdown>
      </widgetInputWrapper>

      <widgetInputWrapper title="Subject*">
        <widgetInput v-model="form.subject" type="text" placeholder="Add Your Subject"></widgetInput>
      </widgetInputWrapper>

      <widgetInputWrapper title="Additional message"
        help="The text you provide here will appear on both the consultant notification tab and the email notification. We advise you to include a clear overview of the survey or form you generated.">
        <html-editor placeholder="Type here..." v-model="form.additional_message" id="edit-descr" />
      </widgetInputWrapper>
    </div>
  </widgetModal>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data: () => {
    return {
      send_loading: false,
      form: {
        questionaire_id: null,
        classes: {
          is_all_classes: false,
          is_my_classes: false,
          selected_classes: [],
        },
        additional_message: "",
        subject: "",
        page: "communication",
      },
      signature_loading: false,
    };
  },
  mounted() {
    let vm = this;
    vm.form = {
      questionaire_id: null,
      classes: {
        is_all_classes: false,
        is_my_classes: false,
        selected_classes: [],
      },
      additional_message: "",
      page: "communication",
    };
    vm.getDefaultSignature();
  },
  computed: {},
  watch: {},
  methods: {
    getDefaultSignature() {
      let vm = this;
      vm.signature_loading = true;
      vm.$store
        .dispatch("PROCESSMESSAGE_EMAIL_GET_DEFAULT_SIGNATURE")
        .then((res) => {
          vm.signature_loading = false;
          vm.form.additional_message = `<br><br><p>Click <a href="https://meritios.com/questionnaire/${vm.value.id}" target="_blank">here</a> to open your questionnaire</p><br>
            ${res.data.message}`;
        })
        .catch((err) => {
          vm.signature_loading = false;
        });
    },
    submitSurvey() {
      let vm = this;
      vm.form.questionaire_id = vm.value.id;
      vm.send_loading = true;
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_SEND_SURVEY", vm.form)
        .then((responce) => {
          vm.send_loading = false;
          vm.$emit("close");
          vm.$notify({
            group: "status",
            title: "Message",
            text:
              vm.type == "evaluation"
                ? "Form sent successfully"
                : "Survey sent successfully",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.send_loading = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something went wrong, please try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
</style>


